import cx from 'classnames'
import * as React from 'react'

import type { FlowCardViewModel } from '../../view-models/FlowCardViewModel'
import CtaButton from '../CtaButton/CtaButton'
import Heading from '../Heading/Heading'
import Image from '../Image/Image'
import Paragraph from '../Paragraph/Paragraph'
import VideoPlayer from '../VideoPlayer/VideoPlayer'
import styles from './flowCard-style.css'

export type FlowCardProps = FlowCardViewModel & {
  className?: string
}

function FlowCard({ title, text, video, image, cta, className }: FlowCardProps) {
  const event = cta ? 'cta' : ''
  const eventData = cta && cta.link ? cta.link.label : ''
  const eventMeta = {
    event,
    eventData,
  }

  return (
    <div className={styles.flowCard}>
      <div className={cx(styles.flowCardContent, className && styles[className])}>
        {title && (
          <Heading
            level={2}
            className={cx(styles.flowCardTextColor, styles.flowCardHeading)}
            noMargin
          >
            {title}
          </Heading>
        )}

        <Paragraph className={cx(styles.flowCardTextColor, styles.flowCardParagraph)}>
          {text}
        </Paragraph>
        {video && <VideoPlayer {...video} />}
        {image && <Image className={styles.image} width={16} height={9} {...image} />}
        {cta && (
          <CtaButton darkBg {...cta} className={styles.button} eventMeta={eventMeta} noUnderline />
        )}
      </div>
    </div>
  )
}

FlowCard.displayName = 'FlowCard'
FlowCard.defaultProps = {}
export default FlowCard